module.exports = __webpack_public_path__ + "img/Notice.b077cedd.svg";